import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["moduleId", "children", "className", "as", "verticalPositioning", "popoverPlacement", "showIndicator", "iconPosition", "iconProps", "outlineRadius", "ctaUrl", "description", "userInfo"];
import useCollaborationSidebarState from 'collaboration-sidebar/hooks/useCollaborationSidebarState';
import ControlledCommentableArea from './ControlledCommentableArea';
import { jsx as _jsx } from "react/jsx-runtime";
function CommentableArea(_ref) {
  let {
      moduleId,
      children,
      className,
      as,
      verticalPositioning,
      popoverPlacement,
      showIndicator,
      iconPosition,
      iconProps,
      outlineRadius,
      ctaUrl,
      description,
      userInfo
    } = _ref,
    propsForWrapper = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState({
    // Fail gracefully if component rendered outside a CollabSidebarStateProvider
    allowNoContext: true
  });
  return /*#__PURE__*/_jsx(ControlledCommentableArea, Object.assign({
    moduleId: moduleId,
    className: className,
    as: as,
    verticalPositioning: verticalPositioning,
    popoverPlacement: popoverPlacement,
    collaborationSidebarState: collaborationSidebarState,
    onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState,
    showIndicator: showIndicator,
    iconPosition: iconPosition,
    iconProps: iconProps,
    outlineRadius: outlineRadius,
    ctaUrl: ctaUrl,
    description: description,
    userInfo: userInfo
  }, propsForWrapper, {
    children: children
  }));
}
export default CommentableArea;